export class AssetGenerationBundle {
    subJobs = [];
    getProgressPercent = () => {
        let progress = 0;
        for (let subJob of this.subJobs) {
            progress += subJob.getProgressPercent();
        }
        return progress / this.subJobs.length;
    };
    add = (bundle) => {
        for (let subJob of bundle.subJobs) {
            this.subJobs.push(subJob);
        }
    };
    toMap = () => {
        return this.subJobs.reduce((map, obj) => {
            map.set(obj.jobId, obj);
            return map;
        }, new Map());
    };
}
export class AssetGenerationProgress {
    jobId;
    progress;
    total;
    getProgressPercent = () => {
        return this.progress / this.total;
    };
    assetUrl;
    error;
}
